export { ReactComponent as DefaultHeaderLogo } from './header-logo.svg';
